import { render, staticRenderFns } from "./AutoClickList.vue?vue&type=template&id=8bd51898&scoped=true&"
import script from "./AutoClickList.vue?vue&type=script&lang=js&"
export * from "./AutoClickList.vue?vue&type=script&lang=js&"
import style0 from "./AutoClickList.vue?vue&type=style&index=0&id=8bd51898&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd51898",
  null
  
)

export default component.exports